/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    'h9Z6yZUguDbqzaedvKw8tW.png': { uri: '/images/h9Z6yZUguDbqzaedvKw8tW.png' },
'frVaL4eLd9Rpc1EyvSUXvK.png': { uri: '/images/frVaL4eLd9Rpc1EyvSUXvK.png' },
'4YLK1Vo8WjtAXy17TuTE6F.png': { uri: '/images/4YLK1Vo8WjtAXy17TuTE6F.png' },
'oi2xGQB2yRGsT6pvERUtER.webp': { uri: '/images/oi2xGQB2yRGsT6pvERUtER.webp' },
'6J8YAAh4YLvGoX36oRK1VB.png': { uri: '/images/6J8YAAh4YLvGoX36oRK1VB.png' },
'xaXnDsZiErczDUyRA37qao.png': { uri: '/images/xaXnDsZiErczDUyRA37qao.png' },
'apnTmVEUW8Q5eSs245LULM.png': { uri: '/images/apnTmVEUW8Q5eSs245LULM.png' },
'caNhsCwavwFDZmFFS9Mug7.png': { uri: '/images/caNhsCwavwFDZmFFS9Mug7.png' },
'tPRjrQyYLwkpxQEMyKQfTf.png': { uri: '/images/tPRjrQyYLwkpxQEMyKQfTf.png' },
'2YpawRCEU8vVxj6dPmeW3w.png': { uri: '/images/2YpawRCEU8vVxj6dPmeW3w.png' },
'6W3mTEB3go9eZ8rL24s5kg.png': { uri: '/images/6W3mTEB3go9eZ8rL24s5kg.png' },
'bdkRG9XB1JvBkwRjARqHt5.png': { uri: '/images/bdkRG9XB1JvBkwRjARqHt5.png' },
'wJBZs4qGkU4TqnvCnTncWv.png': { uri: '/images/wJBZs4qGkU4TqnvCnTncWv.png' },
'a5d6Syepg2zWSt5CnZifNH.png': { uri: '/images/a5d6Syepg2zWSt5CnZifNH.png' },
'pKTnP1xFWGCtBMMbhz6m49.png': { uri: '/images/pKTnP1xFWGCtBMMbhz6m49.png' },
'8UhC8qJGvV8SK59E6QwDmo.png': { uri: '/images/8UhC8qJGvV8SK59E6QwDmo.png' },
'2qk21h54mZhp6A5XioD9uh.png': { uri: '/images/2qk21h54mZhp6A5XioD9uh.png' },
'4ZjQbRktiWscX8xmFW8Jfm.png': { uri: '/images/4ZjQbRktiWscX8xmFW8Jfm.png' },
'1oaG6wJk7NaFBmDdRivi6P.png': { uri: '/images/1oaG6wJk7NaFBmDdRivi6P.png' },
'rz3YqHZ77o5VARzMQqqMfy.png': { uri: '/images/rz3YqHZ77o5VARzMQqqMfy.png' },
'8NiCgc6WSZuGNVnraakyoC.png': { uri: '/images/8NiCgc6WSZuGNVnraakyoC.png' },
'1ZNZcFwnCYFEATaDU2jDdT.png': { uri: '/images/1ZNZcFwnCYFEATaDU2jDdT.png' },
'aVnXpAvNXZowF3e86n2Y2u.png': { uri: '/images/aVnXpAvNXZowF3e86n2Y2u.png' },
'4nS6KT1z4EhtcNqo3z741C.png': { uri: '/images/4nS6KT1z4EhtcNqo3z741C.png' },
'pFXAGw6uKb5nQvYPBfmvJ5.png': { uri: '/images/pFXAGw6uKb5nQvYPBfmvJ5.png' },
'fS4Q4bu55hM3WwCcuiGca4.png': { uri: '/images/fS4Q4bu55hM3WwCcuiGca4.png' },
'bc6U82xHsNtvZvAPMCMNxv.png': { uri: '/images/bc6U82xHsNtvZvAPMCMNxv.png' },
'fVTL3gXAap8Yjy8gAWWe4b.png': { uri: '/images/fVTL3gXAap8Yjy8gAWWe4b.png' },
'9kjxDu9JX4wjkkzRkQaBzQ.png': { uri: '/images/9kjxDu9JX4wjkkzRkQaBzQ.png' },
'uTpQEkoTH5pfA5FWQ48w6z.png': { uri: '/images/uTpQEkoTH5pfA5FWQ48w6z.png' },
'vq7FiXevAg4obrt3Dntmjh.png': { uri: '/images/vq7FiXevAg4obrt3Dntmjh.png' },
'i6smgRv4KghVXkgasKCLGW.png': { uri: '/images/i6smgRv4KghVXkgasKCLGW.png' },
'59BssLuyv9MhbpHM34LAom.png': { uri: '/images/59BssLuyv9MhbpHM34LAom.png' },
'iVSSrveX3aKni9Fd9v1jCh.png': { uri: '/images/iVSSrveX3aKni9Fd9v1jCh.png' },
'nFm1nj6LH4G55ogfKKsMqk.png': { uri: '/images/nFm1nj6LH4G55ogfKKsMqk.png' },
'wfffiZVjQ3VpcPvpHKnVv3.png': { uri: '/images/wfffiZVjQ3VpcPvpHKnVv3.png' },
'gkogpkpP5NEL1MWpjpfyE2.png': { uri: '/images/gkogpkpP5NEL1MWpjpfyE2.png' },
'oeHahnHuCbBQALssKuwZKi.png': { uri: '/images/oeHahnHuCbBQALssKuwZKi.png' },
'qUuKiThyrwgSRreD1BUJMY.png': { uri: '/images/qUuKiThyrwgSRreD1BUJMY.png' },
'66ht8jEJitQ5m9s2hFDChL.png': { uri: '/images/66ht8jEJitQ5m9s2hFDChL.png' },
'mu7ZbE6irzS6YVH34GuMX1.png': { uri: '/images/mu7ZbE6irzS6YVH34GuMX1.png' },
'bVVXufkNMSBNF8yAUmrqgX.png': { uri: '/images/bVVXufkNMSBNF8yAUmrqgX.png' },
'pZNGYeQr5SocfYYUF7Mm2t.png': { uri: '/images/pZNGYeQr5SocfYYUF7Mm2t.png' },
'pYoYUXGcGMGk7AoxmkkiVa.png': { uri: '/images/pYoYUXGcGMGk7AoxmkkiVa.png' },
'j67D6ff3pvrPiRUagiFxgc.png': { uri: '/images/j67D6ff3pvrPiRUagiFxgc.png' },
'wdAQHPJMQpfXRJjLfpPwMV.jpg': { uri: '/images/wdAQHPJMQpfXRJjLfpPwMV.jpg' },
'powHs9YpGgWv6S2AAchrJW.png': { uri: '/images/powHs9YpGgWv6S2AAchrJW.png' },
'3jSQ6WYMH4RvRC4uMyugef.png': { uri: '/images/3jSQ6WYMH4RvRC4uMyugef.png' },
'cvcPNppj9Js1VNcZ7NCcqw.png': { uri: '/images/cvcPNppj9Js1VNcZ7NCcqw.png' },
'4EJZNAdPiLjAKHSTPjnzwb.png': { uri: '/images/4EJZNAdPiLjAKHSTPjnzwb.png' },
'gAPTtvhPYWtscSYurq65H8.png': { uri: '/images/gAPTtvhPYWtscSYurq65H8.png' },
'cHfTe14WEwGNGmQW294eBB.png': { uri: '/images/cHfTe14WEwGNGmQW294eBB.png' },
'jre29kq91MyfrDjwew99tk.png': { uri: '/images/jre29kq91MyfrDjwew99tk.png' },
'rv2LX1nVEV9qXD8iu8gntU.png': { uri: '/images/rv2LX1nVEV9qXD8iu8gntU.png' },
'8ChUxfqZ1D5SdRKzTNvN8m.jpg': { uri: '/images/8ChUxfqZ1D5SdRKzTNvN8m.jpg' },
'8Tv9x6fgeEf7FHuHfcfodp.jpg': { uri: '/images/8Tv9x6fgeEf7FHuHfcfodp.jpg' },
'epm6jAgBmBcrJRdrdmLogL.jpg': { uri: '/images/epm6jAgBmBcrJRdrdmLogL.jpg' },
'oWN1SSWmpD7KiVwAAaF26j.png': { uri: '/images/oWN1SSWmpD7KiVwAAaF26j.png' },
'4txn4AzSBVBkDuJskoMYLy.png': { uri: '/images/4txn4AzSBVBkDuJskoMYLy.png' },
'5pbF1uqNyp4YDDUqcwGMX3.png': { uri: '/images/5pbF1uqNyp4YDDUqcwGMX3.png' },
'fThwocmGBzL1n8uGGmMpYV.png': { uri: '/images/fThwocmGBzL1n8uGGmMpYV.png' },
'qNgPvs9EcLBTatHgxxrY49.jpg': { uri: '/images/qNgPvs9EcLBTatHgxxrY49.jpg' },
'wm6zw5TReSNfUPZzBLDTBq.png': { uri: '/images/wm6zw5TReSNfUPZzBLDTBq.png' },
'2WdiYwmfvtfxqixfrw4FUJ.png': { uri: '/images/2WdiYwmfvtfxqixfrw4FUJ.png' },
'nhX1LsECsbJS2nfpVCEKi6.png': { uri: '/images/nhX1LsECsbJS2nfpVCEKi6.png' },
't2c3th4YPo6xPkWEoTGchn.png': { uri: '/images/t2c3th4YPo6xPkWEoTGchn.png' },
'mzvWYeEMn7zQqyN7qyCNT8.png': { uri: '/images/mzvWYeEMn7zQqyN7qyCNT8.png' },
'vASN57h8ygRQNVw58Yj6zN.png': { uri: '/images/vASN57h8ygRQNVw58Yj6zN.png' },
'rQYs3w6GPfyEwozEBRf353.png': { uri: '/images/rQYs3w6GPfyEwozEBRf353.png' },
'9dmtB1YQJXQ1bEjKD7rvUt.png': { uri: '/images/9dmtB1YQJXQ1bEjKD7rvUt.png' },
'bPPAimKHn8sDUJrhHWExaJ.png': { uri: '/images/bPPAimKHn8sDUJrhHWExaJ.png' },
'ojaEbi2M1yJCjbLwdzsocq.png': { uri: '/images/ojaEbi2M1yJCjbLwdzsocq.png' },
'5PbmdemdWU4uW2sUvgxJsS.png': { uri: '/images/5PbmdemdWU4uW2sUvgxJsS.png' },
'5W1rhov1qk57i1szTMM8Bv.png': { uri: '/images/5W1rhov1qk57i1szTMM8Bv.png' },
'pwZJYhguA5yXdgEB5YmroW.png': { uri: '/images/pwZJYhguA5yXdgEB5YmroW.png' },
'3zZ6DwhYFURumzrqbsCPvB.png': { uri: '/images/3zZ6DwhYFURumzrqbsCPvB.png' },
'u5t652wc8TVpNbArXtanAa.png': { uri: '/images/u5t652wc8TVpNbArXtanAa.png' },
'cSp9aCmMEAiDcTbp7Zjmz5.png': { uri: '/images/cSp9aCmMEAiDcTbp7Zjmz5.png' },
'pMbxk1W3CxSRRv1xbG7PFD.png': { uri: '/images/pMbxk1W3CxSRRv1xbG7PFD.png' },
'q7DR8ZdRkT3K4XFpjit6Km.png': { uri: '/images/q7DR8ZdRkT3K4XFpjit6Km.png' },
'wCnKeAxL8zdiwekmZJRXeg.png': { uri: '/images/wCnKeAxL8zdiwekmZJRXeg.png' },
'dLVH4teAhnSaWdvCEAQm27.png': { uri: '/images/dLVH4teAhnSaWdvCEAQm27.png' },
'9XfHSsjHjtyUir7qHQJL5n.png': { uri: '/images/9XfHSsjHjtyUir7qHQJL5n.png' },
'bUy3ajC8Sng5ffijMGAeCf.png': { uri: '/images/bUy3ajC8Sng5ffijMGAeCf.png' },
'sRwcSA8NLb8Zr6Y36hrEg2.png': { uri: '/images/sRwcSA8NLb8Zr6Y36hrEg2.png' },
'naf45XzvbsZWJPjcUduYV9.png': { uri: '/images/naf45XzvbsZWJPjcUduYV9.png' },
'fisY6ur8BpJxekosrU1h41.png': { uri: '/images/fisY6ur8BpJxekosrU1h41.png' },
'nA2JvNGt9S2ZJA9EBqWwsF.png': { uri: '/images/nA2JvNGt9S2ZJA9EBqWwsF.png' },
'9L7xVGB19bm9vsVjU1WwXc.png': { uri: '/images/9L7xVGB19bm9vsVjU1WwXc.png' },
'xvV7jz43R7DEs9tA5sJnBE.png': { uri: '/images/xvV7jz43R7DEs9tA5sJnBE.png' },
's2j56E5wCYBXRZhccdamro.png': { uri: '/images/s2j56E5wCYBXRZhccdamro.png' },
'vCSUk3kCzTQ2qatL5QESxb.png': { uri: '/images/vCSUk3kCzTQ2qatL5QESxb.png' },
'2sGRZ4dL5TRLMjxJxMvkh5.png': { uri: '/images/2sGRZ4dL5TRLMjxJxMvkh5.png' },
'cQ29kujHHUEYMc6bZWjRX1.png': { uri: '/images/cQ29kujHHUEYMc6bZWjRX1.png' },
'4CAsu4WN3ZAkj8PAGj1vu6.png': { uri: '/images/4CAsu4WN3ZAkj8PAGj1vu6.png' },
'8FQvZnM3uhFUeoM97DnB7V.png': { uri: '/images/8FQvZnM3uhFUeoM97DnB7V.png' },
'4RcHBe58514jmCLecp5h4u.png': { uri: '/images/4RcHBe58514jmCLecp5h4u.png' },
'5XWmKPXT9GoiKkwEpRTxzu.png': { uri: '/images/5XWmKPXT9GoiKkwEpRTxzu.png' },
'27CUUKWHScpe3Pakh5BmCF.jpg': { uri: '/images/27CUUKWHScpe3Pakh5BmCF.jpg' },
'g7FgCQbyvmkbmqT7xAsJY5.png': { uri: '/images/g7FgCQbyvmkbmqT7xAsJY5.png' },
'99UQBtNDTD3QtoHNVgevcV.png': { uri: '/images/99UQBtNDTD3QtoHNVgevcV.png' },
'mYRm4xJcTXHiQmEEncVxPn.png': { uri: '/images/mYRm4xJcTXHiQmEEncVxPn.png' },
'eZTrVKHhSfNPqV2f7Ve8yg.png': { uri: '/images/eZTrVKHhSfNPqV2f7Ve8yg.png' },
'vkXtjQhEFEYQsd6qCMrqf2.png': { uri: '/images/vkXtjQhEFEYQsd6qCMrqf2.png' },
'3j43DhAfMd9w8w8QVH24jS.png': { uri: '/images/3j43DhAfMd9w8w8QVH24jS.png' },
'g5LGZJ4faKtyowPhZCTmhV.jpg': { uri: '/images/g5LGZJ4faKtyowPhZCTmhV.jpg' },
'jigxCs84gu7BknWxNjKxnU.jpg': { uri: '/images/jigxCs84gu7BknWxNjKxnU.jpg' },
'aSfV8LUVmeY4WTQoSybzVG.jpg': { uri: '/images/aSfV8LUVmeY4WTQoSybzVG.jpg' },
'4NxBu7e6TsW5cCnQMQZUev.png': { uri: '/images/4NxBu7e6TsW5cCnQMQZUev.png' },
'inz2HzGZn7NcA2ArufRBYP.jpg': { uri: '/images/inz2HzGZn7NcA2ArufRBYP.jpg' },
'e26TKazSvm3BsiaDQgY3ut.jpg': { uri: '/images/e26TKazSvm3BsiaDQgY3ut.jpg' },
'jUDrSVyaMCSKo7KeHmALvD.png': { uri: '/images/jUDrSVyaMCSKo7KeHmALvD.png' },
'j6J7QE2wiEvfXE23xvkjkd.png': { uri: '/images/j6J7QE2wiEvfXE23xvkjkd.png' },
'edjmZ11yNDQwDCAtVmuLVP.jpg': { uri: '/images/edjmZ11yNDQwDCAtVmuLVP.jpg' },
'3pnuUSjx3iw6CTWTXtes3D.png': { uri: '/images/3pnuUSjx3iw6CTWTXtes3D.png' },
'2YJT63DH2NfqDpy3S3D4SR.png': { uri: '/images/2YJT63DH2NfqDpy3S3D4SR.png' }
}

export default imageStaticSourcesByFileName
